
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/popular-design",
      function () {
        return require("private-next-pages/popular-design.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/popular-design"])
      });
    }
  